import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsSummaryComponent } from './comments-summary.component';



@NgModule({
  declarations: [
    CommentsSummaryComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CommentsSummaryComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class CommentsSummaryModule { }
